import { EVENT_NAME } from '../utils/fptiUtils'
import {
  MERCHANT_DATA_PRIVACY,
  DATA_PRIVACY_HOME,
  DATA_PRIVACY_MANAGECOOKIES,
  MERCHANT_DATA_PRIVACY_MANAGECOOKIES,
  DATA_PRIVACY_PROFILE_SEARCH,
  DATA_PRIVACY_HOME_PROFILE_SEARCH,
  MERCHANT_DATA_PRIVACY_BLOCKED_CONTACTS,
  DATA_PRIVACY_HOME_BLOCKED_CONTACTS,
  MERCHANT_DATA_PRIVACY_DOWNLOAD_DATA,
  DATA_PRIVACY_HOME_DOWNLOAD_DATA,
  DATA_PRIVACY_HOME_CORRECT_DATA,
  MERCHANT_DATA_PRIVACY_DELETE_DATA,
  MERCHANT_DATA_PRIVACY_CORRECT_DATA,
  DATA_PRIVACY_HOME_DELETE_DATA,
  PRIVACY_MERCHANT_COMPONENT,
  PRIVACY_CONSUMER_COMPONENT,
  DATA_PRIVACY_FACE_SCAN,
  MERCHANT_DATA_PRIVACY_DAR_REQUEST,
  DATA_PRIVACY_HOME_DAR_REQUEST,
  FACESCAN_PAGE_DELETE_BTN,
  FACESCAN_PAGE_CONFIRM_DELETE_BTN,
  DATA_PRIVACY_SHOPPING,
  DATA_PRIVACY_SHARED_RECOMMENDATIONS,
} from '../constants/constants'

const getFptiData = ({ pgrp, page, product }, link, eventName) => {
  return {
    pgrp,
    page,
    link,
    product,
    event_name: eventName,
  }
}
const getExtendedFptiData = (
  { pgrp, page, pglk, pgln, comp },
  link,
  eventName,
) => {
  return {
    pgrp,
    page,
    pglk,
    pgln,
    comp,
    product: comp,
    link,
    event_name: eventName,
  }
}
const fptiConfig = {
  manageCookies: {
    merchant: {
      pgrp: MERCHANT_DATA_PRIVACY,
      page: MERCHANT_DATA_PRIVACY,
      pglk: MERCHANT_DATA_PRIVACY_MANAGECOOKIES,
      pgln: MERCHANT_DATA_PRIVACY_MANAGECOOKIES,
      comp: PRIVACY_MERCHANT_COMPONENT,
    },
    consumer: {
      pgrp: DATA_PRIVACY_HOME,
      page: DATA_PRIVACY_HOME,
      pglk: DATA_PRIVACY_MANAGECOOKIES,
      pgln: DATA_PRIVACY_MANAGECOOKIES,
      comp: PRIVACY_CONSUMER_COMPONENT,
    },
  },
  searchPrivacy: {
    merchant: {
      pgrp: MERCHANT_DATA_PRIVACY,
      page: MERCHANT_DATA_PRIVACY,
      pglk: DATA_PRIVACY_PROFILE_SEARCH,
      pgln: DATA_PRIVACY_PROFILE_SEARCH,
      comp: PRIVACY_MERCHANT_COMPONENT,
    },
    consumer: {
      pgrp: DATA_PRIVACY_HOME,
      page: DATA_PRIVACY_HOME,
      pglk: DATA_PRIVACY_HOME_PROFILE_SEARCH,
      pgln: DATA_PRIVACY_HOME_PROFILE_SEARCH,
      comp: PRIVACY_CONSUMER_COMPONENT,
    },
  },
  blockedContacts: {
    merchant: {
      pgrp: MERCHANT_DATA_PRIVACY,
      page: MERCHANT_DATA_PRIVACY,
      pglk: MERCHANT_DATA_PRIVACY_BLOCKED_CONTACTS,
      pgln: MERCHANT_DATA_PRIVACY_BLOCKED_CONTACTS,
      comp: PRIVACY_MERCHANT_COMPONENT,
    },
    consumer: {
      pgrp: DATA_PRIVACY_HOME,
      page: DATA_PRIVACY_HOME,
      pglk: DATA_PRIVACY_HOME_BLOCKED_CONTACTS,
      pgln: DATA_PRIVACY_HOME_BLOCKED_CONTACTS,
      comp: PRIVACY_CONSUMER_COMPONENT,
    },
  },
  downloadData: {
    merchant: {
      pgrp: MERCHANT_DATA_PRIVACY,
      page: MERCHANT_DATA_PRIVACY,
      pglk: MERCHANT_DATA_PRIVACY_DOWNLOAD_DATA,
      pgln: MERCHANT_DATA_PRIVACY_DOWNLOAD_DATA,
      comp: PRIVACY_MERCHANT_COMPONENT,
    },
    consumer: {
      pgrp: DATA_PRIVACY_HOME,
      page: DATA_PRIVACY_HOME,
      pglk: DATA_PRIVACY_HOME_DOWNLOAD_DATA,
      pgln: DATA_PRIVACY_HOME_DOWNLOAD_DATA,
      comp: PRIVACY_CONSUMER_COMPONENT,
    },
  },
  correctData: {
    merchant: {
      pgrp: MERCHANT_DATA_PRIVACY,
      page: MERCHANT_DATA_PRIVACY,
      pglk: MERCHANT_DATA_PRIVACY_CORRECT_DATA,
      pgln: MERCHANT_DATA_PRIVACY_CORRECT_DATA,
      comp: PRIVACY_MERCHANT_COMPONENT,
    },
    consumer: {
      pgrp: DATA_PRIVACY_HOME,
      page: DATA_PRIVACY_HOME,
      pglk: DATA_PRIVACY_HOME_CORRECT_DATA,
      pgln: DATA_PRIVACY_HOME_CORRECT_DATA,
      comp: PRIVACY_CONSUMER_COMPONENT,
    },
  },
  facescan: {
    consumer: {
      pgrp: DATA_PRIVACY_HOME,
      page: DATA_PRIVACY_HOME,
      pglk: DATA_PRIVACY_FACE_SCAN,
      pgln: DATA_PRIVACY_FACE_SCAN,
      comp: PRIVACY_CONSUMER_COMPONENT,
    },
  },
  deleteData: {
    merchant: {
      pgrp: MERCHANT_DATA_PRIVACY,
      page: MERCHANT_DATA_PRIVACY,
      pglk: MERCHANT_DATA_PRIVACY_DELETE_DATA,
      pgln: MERCHANT_DATA_PRIVACY_DELETE_DATA,
      comp: PRIVACY_MERCHANT_COMPONENT,
    },
    consumer: {
      pgrp: DATA_PRIVACY_HOME,
      page: DATA_PRIVACY_HOME,
      pglk: DATA_PRIVACY_HOME_DELETE_DATA,
      pgln: DATA_PRIVACY_HOME_DELETE_DATA,
      comp: PRIVACY_CONSUMER_COMPONENT,
    },
  },
  dataDar: {
    merchant: {
      pgrp: MERCHANT_DATA_PRIVACY,
      page: MERCHANT_DATA_PRIVACY,
      pglk: MERCHANT_DATA_PRIVACY_DAR_REQUEST,
      pgln: MERCHANT_DATA_PRIVACY_DAR_REQUEST,
      comp: PRIVACY_MERCHANT_COMPONENT,
    },
    consumer: {
      pgrp: DATA_PRIVACY_HOME,
      page: DATA_PRIVACY_HOME,
      pglk: DATA_PRIVACY_HOME_DAR_REQUEST,
      pgln: DATA_PRIVACY_HOME_DAR_REQUEST,
      comp: PRIVACY_CONSUMER_COMPONENT,
    },
  },
  shopping_setting: {
    pgrp: DATA_PRIVACY_SHOPPING,
    page: DATA_PRIVACY_SHOPPING,
    product: PRIVACY_CONSUMER_COMPONENT,
  },
  default: {
    pgrp: DATA_PRIVACY_HOME,
    page: DATA_PRIVACY_HOME,
    product: PRIVACY_CONSUMER_COMPONENT,
  },
  facescan_setting: {
    product: PRIVACY_CONSUMER_COMPONENT,
  },
  recommendations: {
    consumer: {
      pgrp: DATA_PRIVACY_HOME,
      page: DATA_PRIVACY_HOME,
      pglk: DATA_PRIVACY_SHARED_RECOMMENDATIONS,
      pgln: DATA_PRIVACY_SHARED_RECOMMENDATIONS,
      comp: PRIVACY_CONSUMER_COMPONENT,
    },
  },
}

export const pageSpec = {
  landing_data_and_privacy_page: ({ xe, xt, pageName }) => {
    return {
      pgrp: `main:dataprivacy:${pageName}`,
      page: `main:dataprivacy:${pageName}`,
      pglk: `main:dataprivacy:${pageName}:data_privacy`,
      xe,
      xt,
      event_name: EVENT_NAME.DATA_PRIVACY_LANDING_PAGE_SCREEN_SHOWN,
    }
  },
  privacy_sections_permissions_given_Link: () => {
    return getFptiData(
      fptiConfig.default,
      'permissions_given',
      EVENT_NAME.PRIVACY_SECTION_PERMISSIONS_GIVEN_LINK_CLICKED,
    )
  },
  privacy_section_pp_shopping_link: () => {
    return getFptiData(
      fptiConfig.default,
      'pp_shopping',
      EVENT_NAME.PRIVACY_SECTION_PP_SHOPPING_LINK_CLICKED,
    )
  },
  privacy_section_interest_marketing_link: () => {
    return getFptiData(
      fptiConfig.default,
      'marketing_offers',
      EVENT_NAME.PRIVACY_SECTION_INTERST_MARKETING_LINK_CLICKED,
    )
  },
  privacy_section_manage_cookie_link: (isMerchantUser) => {
    const fptiData = isMerchantUser
      ? fptiConfig.manageCookies.merchant
      : fptiConfig.manageCookies.consumer
    return getExtendedFptiData(
      fptiData,
      'manage_cookies',
      EVENT_NAME.PRIVACY_SECTION_MANAGE_COOKIES_LINK_CLICKED,
    )
  },
  privacy_section_search_privacy_link: (isMerchantUser) => {
    const fptiData = isMerchantUser
      ? fptiConfig.searchPrivacy.merchant
      : fptiConfig.searchPrivacy.consumer
    return getExtendedFptiData(
      fptiData,
      'profiles_search',
      EVENT_NAME.PRIVACY_SECTION_SEARCH_PRIVACY_LINK_CLICKED,
    )
  },
  privacy_section_blocked_contacts_link: (isMerchantUser) => {
    const fptiData = isMerchantUser
      ? fptiConfig.blockedContacts.merchant
      : fptiConfig.blockedContacts.consumer
    return getExtendedFptiData(
      fptiData,
      'blocked_contacts',
      EVENT_NAME.PRIVACY_SECTION_BLOCKED_CONTACTS_LINK_CLICKED,
    )
  },
  privacy_section_download_data_link: (isMerchantUser) => {
    const fptiData = isMerchantUser
      ? fptiConfig.downloadData.merchant
      : fptiConfig.downloadData.consumer
    return getExtendedFptiData(
      fptiData,
      'download_data',
      EVENT_NAME.PRIVACY_SECTION_DOWNLOAD_DATA_LINK_CLICKED,
    )
  },
  privacy_section_correct_data_link: (isMerchantUser) => {
    const fptiData = isMerchantUser
      ? fptiConfig.correctData.merchant
      : fptiConfig.correctData.consumer
    return getExtendedFptiData(
      fptiData,
      'correct_data',
      EVENT_NAME.PRIVACY_SECTION_CORRECT_DATA_LINK_CLICKED,
    )
  },
  privacy_section_manage_face_scan_link: () => {
    return getExtendedFptiData(
      fptiConfig.facescan.consumer,
      'manage_face_scan',
      EVENT_NAME.PRIVACY_SECTION_MANAGE_FACE_SCAN_LINK_CLICKED,
    )
  },
  privacy_section_delete_data_link: (isMerchantUser) => {
    const fptiData = isMerchantUser
      ? fptiConfig.deleteData.merchant
      : fptiConfig.deleteData.consumer
    return getExtendedFptiData(
      fptiData,
      'delete_data',
      EVENT_NAME.PRIVACY_SECTION_DELETE_DATA_LINK_CLICKED,
    )
  },
  privacy_section_data_request_history_link: (isMerchantUser) => {
    const fptiData = isMerchantUser
      ? fptiConfig.dataDar.merchant
      : fptiConfig.dataDar.consumer
    return getExtendedFptiData(
      fptiData,
      'your_request',
      EVENT_NAME.PRIVACY_SECTION_DAR_HISTORY_LINK_CLICKED,
    )
  },
  privacy_section_shared_recommendations_link: () => {
    return getExtendedFptiData(
      fptiConfig.recommendations.consumer,
      'shared_recommendations',
      EVENT_NAME.PRIVACY_SECION_SHARED_RECOMMENDATIONS_LINK_CLICKED,
    )
  },
  //shopping_setting fpti data
  shopping_setting_page: {
    ...fptiConfig.shopping_setting,
    event_name: EVENT_NAME.SHOPPING_SETTING_PAGE,
  },
  getLinkData: (setting, link, eventName, obj = {}) => {
    return {
      ...getFptiData(fptiConfig[setting], link, eventName),
      ...obj,
    }
  },
  manage_face_scan_delete_btn: {
    ...getFptiData(
      {
        pgrp: FACESCAN_PAGE_DELETE_BTN,
        page: FACESCAN_PAGE_DELETE_BTN,
        ...fptiConfig.facescan_setting,
      },
      'deleteFaceScanData',
      EVENT_NAME.MANAGE_FACE_SCAN_DELETE_BUTTON_CLICKED,
    ),
  },
  delete_face_scan_modal_delete_btn: {
    ...getFptiData(
      {
        pgrp: FACESCAN_PAGE_CONFIRM_DELETE_BTN,
        page: FACESCAN_PAGE_CONFIRM_DELETE_BTN,
        ...fptiConfig.facescan_setting,
      },
      'confirmDeleteFaceScanData',
      EVENT_NAME.DELETE_FACE_SCAN_MODAL_DELETE_BUTTON_CLICKED,
    ),
  },
}
